<template>
	<dynvibebasechart
		:id="axiosComputed"
		ref="basechart"
		@created="chartCreated"
		:functionClick="clickGraph"
		:type="type"
	></dynvibebasechart>
</template>
<script>
import graphMixin from "@/mixins/graphMixin.js";
import Highcharts from "highcharts"; // because Highcharts.Theme. Better solution ?

export default {
	name: "dynvibepie",
	mixins: [graphMixin],
	data() {
		return {
			pourcent: false,
			baseChart: undefined,
		};
	},
	mounted() {
		setTimeout(() => {
			this.baseChart = this.$refs.basechart;
			this.setChartOptions();
		}, 250);
	},
	methods: {
		setChartOptions() {
			let baseChart = this.$refs.basechart;
			let chartOptions = baseChart.getChartOptions();
			chartOptions.chart.type = "pie";
			chartOptions.title = {
				text: "",
				align: "center",
				verticalAlign: "middle",
				y: 10,
				floating: true,
				style: {
					color: "#EEE",
					fontFamily: "Intro",
					fontSize: "40px",
					fontWeight: "bold",
					position: "absolute",
				},
			};
			chartOptions.subtitle = {
				text: "",
				align: "center",
				verticalAlign: "middle",
				y: 15,
				floating: true,
				style: { fontSize: "15px", textTransform: "uppercase", color: "#7C7C7C", marginBottom: "15px" },
			};
			chartOptions.legend.reversed = false;
			delete chartOptions.xAxis;
			delete chartOptions.yAxis;
			delete chartOptions.plotOptions.bar;
			chartOptions.tooltip = {
				enabled: true,
			};
			chartOptions.plotOptions.pie = {
				dataLabels: false,
				allowPointSelect: false,
				showInLegend: true,
				point: {
					events: {
						legendItemClick: (event) => {
							let point = event.target;
							let chart = point.series.chart;
							if (chart.title) {
								if (point.visible) {
									let nameSeries = point.name;
									let noActive = true;
									chart.series[0].points.forEach((serie) => {
										if (serie.name !== nameSeries && serie.visible) {
											noActive = false;
											let graph_donut_val = serie.y;
											if (this.pourcent) {
												graph_donut_val = serie.y.toFixed(1) + "%";
											}
											chart.update(this.changeTitle(graph_donut_val, serie.color, serie.name));
										}
										if (noActive) {
											chart.update(this.changeTitle("", "transparent", ""));
										}
									});
								} else {
									let graph_donut_val = point.y;
									if (this.pourcent) {
										graph_donut_val = point.y.toFixed(1) + "%";
									}
									chart.update(this.changeTitle(graph_donut_val, point.color, point.name));
								}
							}
						},
						mouseOver: (event) => {
							let point = event.target;
							let chart = point.series.chart;
							if (chart.title.textStr) {
								let graph_donut_val = point.y;
								if (this.pourcent) {
									if (point.series.data[0].y === 100) {
										graph_donut_val = point.y.toFixed(0) + "%";
									} else {
										graph_donut_val = point.y.toFixed(1) + "%";
									}
								}
								chart.update(this.changeTitle(graph_donut_val, point.color, point.name));
							}
						},
					},
				},
				states: {
					hover: {
						halo: {
							opacity: 1,
							size: 18,
						},
						brightness: 0,
						lineWidthPlus: 0,
						shadow: true,
					},
				},
				cursor: "pointer",
				borderWidth: 1,
				borderColor: null,
				size: "100%",
				innerSize: "50%",
				style: {
					color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || "black",
				},
			};
			baseChart.updateChartOptions(chartOptions);
		},
		loadChartData(results) {
			let baseChart = this.$refs.basechart;
			let chartOptions = baseChart.getChartOptions();

			chartOptions.series = [{ data: results.values }];
			if (!results.values[0]) {
				chartOptions.title.text = null;
				chartOptions.subtitle.text = null;
				return;
			}
			let graph_donut_val = results.values[0].y;
			if (results.pourcent) {
				this.pourcent = true;
				if (results.values[0].y === 100) {
					graph_donut_val = results.values[0].y.toFixed(0) + "%";
				} else {
					graph_donut_val = results.values[0].y.toFixed(1) + "%";
				}
			}
			let color = results.values[0].color;
			chartOptions.title.text = graph_donut_val;
			chartOptions.title.style.color = color;
			chartOptions.subtitle.text = results.values[0].name;

			baseChart.updateChartOptions(chartOptions);
		},
		changeTitle(title, color, subtitle) {
			return {
				title: {
					text: title,
					align: "center",
					verticalAlign: "middle",
					y: 10,
					floating: true,
					style: {
						color: color,
						fontFamily: "Intro",
						fontSize: "40px",
						fontWeight: "bold",
						position: "absolute",
					},
				},
				subtitle: {
					text: subtitle,
					align: "center",
					verticalAlign: "middle",
					y: 15,
					floating: true,
					style: { fontSize: "15px", textTransform: "uppercase", color: "#7C7C7C", marginBottom: "15px" },
				},
			};
		},
	},
};
</script>
